import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGetOneIngredientReferenceUnified } from "src/api/client-api/ingredientReferenceUnified/useGetOneIngredientReferenceUnified";
import { buildCompositeId } from "src/api/client-api/ingredientReferenceUnified/types";

type Ingredient = {
    name?: string | null;
    clientId?: string | null;
    organic?: boolean | null;
    ingredientReferenceId?: number | null;
    referenceSource?: "sure" | "foodpilot" | null;
    ingredientLine?: {
        "@id": IRI;
        name: string;
    } | null;
};

export type InfoSectionProps = {
    ingredient: Ingredient;
};
export const InformationSummary = (props: InfoSectionProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { ingredient } = props;
    const compositeId =
        ingredient.ingredientReferenceId != null ?
            buildCompositeId(ingredient.referenceSource ?? "sure", ingredient.ingredientReferenceId)
        :   undefined;
    const { ingredientReference } = useGetOneIngredientReferenceUnified(compositeId);

    const noValue = "-";
    return (
        <Box
            component="table"
            sx={{
                display: "table",
                width: "100%",
                "&>tr>td": {
                    width: "430px",
                    borderBottom: `1px solid ${theme.custom.grey[500]}`,
                    padding: "20px 0px",
                },
            }}
        >
            <tr>
                <td>
                    <Typography variant="big-bold">{t("nom_de_l_ingredient")}</Typography>
                </td>
                <td>
                    <Typography variant="body-medium">{ingredient.name ?? noValue}</Typography>
                </td>
            </tr>
            <tr>
                <td>
                    <Typography variant="big-bold">{t("unique_identifier")}</Typography>
                </td>
                <td>
                    <Typography variant="body-medium">{ingredient.clientId ?? noValue}</Typography>
                </td>
            </tr>
            <tr>
                <td>
                    <Typography variant="big-bold">{t("filiere")}</Typography>
                </td>
                <td>
                    <Typography variant="body-medium">{ingredient.ingredientLine?.name ?? noValue}</Typography>
                </td>
            </tr>
            <tr>
                <td>
                    <Typography variant="big-bold">{t("ingredient_issu_de_l_agriculture_biologique")}</Typography>
                </td>
                <td>
                    <Typography variant="body-medium">
                        {ingredient.organic ? t("common.yes", "Yes") : t("common.no", "No")}
                    </Typography>
                </td>
            </tr>
            <tr>
                <td>
                    <Typography variant="big-bold">{t("ingredient_de_reference_associe")}</Typography>
                </td>
                <td>
                    <Typography variant="body-medium">{ingredientReference?.name ?? noValue}</Typography>
                </td>
            </tr>
        </Box>
    );
};
